<template>
  <div>
    <b-card class="col-lg-4 col-md-6 col-sm-12" no-body>
      <div class="m-2">

        <!-- Table Top -->
        <b-row class="pb-1">
          <b-col cols="6">
            <b-form-group label="Nhập số thuê bao Itel">
              <validation-provider #default="{ errors }">
                <b-form-input v-model="msisdn" :state="errors.length > 0 ? false:null" placeholder="087xxx"
                              @keypress.enter="loadData"/>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Per Page -->
        </b-row>
      </div>
    </b-card>

    <b-row>
      <b-col lg="12" md="12">
        <b-card v-if="balance" body-class="p-0">
          <div class="">

            <table class="table table-sm table-bordered table-striped">
              <thead>
              <tr>
                <th>Thông tin</th>
                <th>Dữ liệu chi tiết</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>Tài khoản chính</td>
                <td>{{ balance.coreBalance|number }}</td>
              </tr>
              <tr>
                <td>Hạn sử dụng TKC</td>
                <td>{{ balance.coreBalanceExp }}</td>
              </tr>
              <tr>
                <td>Tài khoản KM1</td>
                <td>{{ balance.tkkm1|number }}</td>
              </tr>
              <tr>
                <td>Hạn sử dụng TKKM1</td>
                <td>{{ balance.tkkm1Exp }}</td>
              </tr>
              <tr>
                <td>Tài khoản KM2</td>
                <td>{{ balance.tkkm2|number }}</td>
              </tr>
              <tr>
                <td>Hạn sử dụng TKKM2</td>
                <td>{{ balance.tkkm2Exp }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
    </b-row>


  </div>
</template>

<script>


import {ValidationObserver, ValidationProvider} from 'vee-validate'
import {required} from '@validations'
import vSelect from 'vue-select'
import {VueGoodTable} from 'vue-good-table'
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTable,
  BTooltip,
  VBTooltip
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue';
import Ripple from 'vue-ripple-directive'
import '@core/scss/vue/libs/vue-good-table.scss';
import Select2 from 'v-select2-component';


export default {

  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2
  },

  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mounted() {


  },
  watch: {},
  methods: {
    async loadData() {
      this.$store.dispatch('crm/fetchBalance', this);
    },
  },
  data() {
    return {
      msisdn: '',
      balance: null,
      isLoading: false,
      required
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
